import { KYMW2400Component } from './kymw2400.component';
import { SectionTemplateModel } from './vo/section-template.model';
import { PageTemplateIDModel } from './vo/page-template-id.model';
import { PageTemplateModel } from './vo/page-template.model';

/**
 * ページテンプレート画面の値を管理するクラス
 *
 * @export KYMW2400Model
 * @class KYMW2400Model
 */
export class KYMW2400Model {

  kymw2400Component: KYMW2400Component;

  /**
   * ページテンプレートリスト
   */
  public pageTemplateList: Array<any> = null;

  /**
   * ページテンプレートデータ
   */
  public pageTemplateData: any = null;

  /**
   * 新規テンプレートデータ
   */
  public newTemplateData: any = new Object();

  /**
   * 選択ページ情報
   */
  public selectedPageInfo: any = new Object();

  /**
   * 選択セクション情報
   */
  public selectedSectionInfo: any = new Object();

  /**
   * 編集可能ページフラグ
   */
  public editablePageFlag: boolean = null;

  /**
   * ページテンプレートID
   */
  private pageTemplateID: string = null;

  public disabledNewTemplate = Boolean(false);
  public disabledEditTemplate = Boolean(false);
  public hiddenAllListFlg = Boolean(false);
  public hiddenNewPageFlg = Boolean(true);
  public hiddenEditPageFlg = Boolean(true);

  /**
   * ページテンプレートリスト更新
   *
   * @param {*} serverData
   * @memberof KYMW2400Model
   */
  public updatePageTemplateList(serverData: any): void {
    if (serverData != null) {
      this.pageTemplateList = serverData;
    }
  }

  /**
   * ページテンプレートID変更
   *
   * @param {int} pageTempateIndex
   * @memberof KYMW2400Model
   */
  public changePageTemplateID(pageTempateIndex: number): void {
    this.selectedPageInfo = this.pageTemplateList[pageTempateIndex];
    this.pageTemplateID = this.pageTemplateList[pageTempateIndex].PageTemplateID;

    if (this.pageTemplateList[pageTempateIndex].DefaultTemplate === '○' ||
      this.pageTemplateList[pageTempateIndex].AutoLocatingEnabled === '○') {
      this.editablePageFlag = false;
    } else {
      this.editablePageFlag = true;
    }
  }

  /**
   * 選択セクション変更
   *
   * @param {SectionTemplateModel} vo
   * @memberof KYMW2400Model
   */
  public changeSelectedSection(vo: SectionTemplateModel): void {
    this.selectedSectionInfo = new Object();
    // 項番2231 START 障害管理NO.U01748対応
    // vo.percentPositionXDisplay = vo.percentPositionX * 100;
    // vo.percentPositionYDisplay = vo.percentPositionY * 100;
    // vo.percentWidthDisplay = vo.percentWidth * 100;
    // vo.percentHeightDisplay = vo.percentHeight * 100;
    vo.percentPositionXDisplay = String(vo.percentPositionX * 100);
    vo.percentPositionYDisplay = String(vo.percentPositionY * 100);
    vo.percentWidthDisplay = String(vo.percentWidth * 100);
    vo.percentHeightDisplay = String(vo.percentHeight * 100);
    this.selectedSectionInfo = vo;
    // 項番2231 END 障害管理NO.U01748対応
  }

  /**
   * ページテンプレートIDVO作成
   *
   * @returns {PageTemplateIDModel}
   * @memberof KYMW2400Model
   */
  public createPageTemplateIDVO(): PageTemplateIDModel {
    const vo: PageTemplateIDModel = new PageTemplateIDModel();
    vo.pageTemplateID = this.pageTemplateID;
    return vo;
  }

  /**
   * ページテンプレートデータ更新
   *
   * @param {*} obj
   * @memberof KYMW2400Model
   */
  public updatePageTemplateData(obj: any): void {
    if (obj != null) {
      this.pageTemplateData = obj;
      this.kymw2400Component.bindPageTemplateDataHandler();
    }
  }

  /**
   * 新規ページ作成
   *
   * @param {PageTemplateModel} vo
   * @memberof KYMW2400Model
   */
  public createNewPage(vo: PageTemplateModel): void {
    const newPageData: Object = {
      PageTemplateID: [''],
      PageTemplateName: [vo.pageTemplateName],
      PageAreaX: [vo.pageAreaX],
      PageAreaY: [vo.pageAreaY],
      PageAreaWidth: [vo.pageAreaWidth],
      PageAreaHeight: [vo.pageAreaHeight],
      DivW: [vo.divW],
      DivH: [vo.divH]
    };
    this.newTemplateData = newPageData;
    this.pageTemplateData = newPageData;
    this.selectedSectionInfo = new Object();
    this.kymw2400Component.bindPageTemplateDataHandler();
    this.kymw2400Component.bindNewTemplateDataHandler();
  }

  /**
   * テンプレートリスト作成
   */
  public clearTemplateList(): void {
    this.pageTemplateList = null;
    this.pageTemplateData = null;
    this.newTemplateData = new Object();
    this.selectedPageInfo = new Object();
    this.selectedSectionInfo = new Object();
    this.pageTemplateID = null;
  }

  /**
   * 編集テンプレートデータクリア
   *
   * @memberof KYMW2400Model
   */
  public clearEditTemplateData(): void {
  }

  /**
   * テンプレートデータクリア
   *
   * @memberof KYMW2400Model
   */
  public clearPageTemplateData(): void {
    this.pageTemplateData = null;
    this.selectedSectionInfo = new Object();
  }

  /**
   * 選択セクション情報クリア
   *
   * @memberof KYMW2400Model
   */
  public clearSelectedSectionInfo(): void {
    this.selectedSectionInfo = new Object();
  }

  /**
   * キャンセルデータ
   *
   * @memberof KYMW2400Model
   */
  public cancelData(): void {
    this.pageTemplateData = null;
    this.newTemplateData = new Object();
    this.selectedPageInfo = new Object();
    this.selectedSectionInfo = new Object();
    this.pageTemplateID = null;
  }

  /**
   * メインデータ設定
   *
   * @memberof KYMW2400Model
   */
  public setMainData(): void {

  }
}
